import * as React from 'react'
import * as Container from "../../container/container";

const Video = (key) => {
    return (
        <Container.Part background="beige" id="trailer" key={key}>
            <Container.Row>
                <div className="col-12">
                    <div className="inner-container">
                        <h2>Eine Begegnung mit Oberbürgermeister Marcus König am Gewerkschaftshaus am Kornmarkt in
                            Nürnberg.</h2>
                        <figure className="video">
                            <div className="yt-container yt-enabled">
                                <Container.Video
                                    url={"/videos/Filmmaterial/007_Nürnberg/210708_Nürnberg mit Intro.mp4"}
                                    poster={"/images/Videowallpaper/nuernberg.jpg"}/>
                            </div>
                        </figure>
                    </div>
                </div>
            </Container.Row>
        </Container.Part>
    )
}

export default Video
